import { create } from 'zustand';
const useMenuStore = create((set) => ({
    open: false,
    setOpen: (open) => {
        set({ open });
    },
}));
export default useMenuStore;
